import firebase from "firebase";

export default async function EvaluateSubmission(pid, evaluation = "deny", comment = "", onSuccess, onFail) {
  const result = await firebase.functions().httpsCallable('EvaluateProduct')({
    pid: pid,
    evaluation: evaluation,
    comment: comment,
  });

  if (result) {
    if (!result.data.result) {
      // logout
      console.error(result.data.message);
      onFail();
    } else {
      try {
        onSuccess();
      } catch (err) {
        console.error(err);
        onFail();
      }
    }
  } else {
    console.error("something went wrong when calling the function");
    onFail();
  }
}